exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".note{width:240px;margin:8px 0;padding:10px;background:#fff;border-radius:2px;box-shadow:0 2px 5px #ccc;transition:box-shadow .5s;cursor:default}.note:focus,.note:hover{box-shadow:0 2px 10px #999}.note:focus button,.note:hover button{opacity:.6}.note h1{margin-bottom:6px}.note h1,.note pre{font-size:1.1em;word-wrap:break-word}.note pre{margin-bottom:10px;white-space:pre-wrap;font-family:inherit}.note button{background:none;border:none;font-size:20px;opacity:0;cursor:pointer;transition:opacity .5s;margin:0 4px 0 0}.note button:focus,.note button:hover{opacity:1}.note button.edit{float:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/notes/Note.scss
// module id = 128
// module chunks = 0